import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Sınıfları birleştirir; çakışan Tailwind sınıflarında sonuncusu kazanır. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
